
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/shopify-app-review-link-generator",
      function () {
        return require("private-next-pages/tools/shopify-app-review-link-generator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/shopify-app-review-link-generator"])
      });
    }
  